<template>
  <subpage-shell
    :eyebrow="trans.get('landing.subpages.stories.eyebrow')"
    :title-prefix="trans.get('landing.subpages.stories.title_prefix')"
    :title-grad="trans.get('landing.subpages.stories.title_grad')"
    :title-suffix="trans.get('landing.subpages.stories.title_suffix')"
    :lede-prefix="trans.get('landing.subpages.stories.lede')"
    nav-active="stories"
  >
    <p class="stories-intro">{{ trans.get('landing.subpages.stories.intro') }}</p>

    <section class="sec stories-page-wrap">
      <div class="stories">
        <article
          v-for="story in stories"
          :key="story.id"
          class="story"
          :class="`s${story.id}`"
        >
          <span class="stat">{{ story.stat }}</span>
          <div
            class="quote-mark"
            :class="story.quoteClass"
          >
            "
          </div>
          <p class="qt">{{ story.quote }}</p>
          <div class="auth">
            <div
              class="av"
              :class="`av--${story.avatar}`"
            ></div>
            <div>
              <div class="nm">{{ story.name }}</div>
              <div class="meta">{{ story.city }}</div>
            </div>
          </div>
        </article>
      </div>
    </section>
  </subpage-shell>
</template>

<script>
import SubpageShell from './SubpageShell.vue';

export default {
  name: 'StoriesPage',
  components: { SubpageShell },
  data() {
    return {
      stories: [
        {
          id: 1,
          stat: 'Mitglied seit \'23',
          quoteClass: '',
          quote: 'Das Quiz Match nimmt den Druck raus. Statt "Hey :)" einfach mal sehen, wer mich ehrlich einschätzt — viel entspannter als das, was ich vorher kannte.',
          avatar: 'mia',
          name: 'Mia, 28',
          city: 'Berlin',
        },
        {
          id: 2,
          stat: '★ 4,8',
          quoteClass: 'quote-mark--pink',
          quote: 'Endlich eine App, bei der nicht nur das Foto zählt. Hier hat Persönlichkeit wieder Bedeutung.',
          avatar: 'sophia-stories',
          name: 'Sophia, 29',
          city: 'München',
        },
        {
          id: 3,
          stat: 'App-Feedback',
          quoteClass: 'quote-mark--coral',
          quote: 'Die Bedienung ist intuitiv und das Quiz ist tatsächlich unterhaltsam — fühlt sich nicht wie Arbeit an.',
          avatar: 'steph',
          name: 'Steph, 38',
          city: 'Hamburg',
        },
        {
          id: 4,
          stat: 'Mitglied',
          quoteClass: 'quote-mark--pink',
          quote: 'Was mich überzeugt hat: weniger Wischen, mehr Substanz. Die Quiz-Fragen sorgen dafür, dass Chats nicht im Sand verlaufen.',
          avatar: 'anna',
          name: 'Anna, 60',
          city: 'Hamburg',
        },
        {
          id: 5,
          stat: '★ 5,0',
          quoteClass: 'quote-mark--coral',
          quote: 'Der Joker ist eine schöne Option, wenn ich jemanden spannend finde. Insgesamt: angenehm unkompliziert.',
          avatar: 'laura',
          name: 'Laura, 45',
          city: 'Frankfurt',
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
/* Header is provided by <subpage-shell>, so the stories grid sits flush
   beneath it without an extra top gap. */
.stories-page-wrap {
  padding-top: 0;
}

.stories-page-wrap > .stories {
  padding: 0 56px;
}

.stories-page-wrap > .stories {
  gap: 18px;
}

@media (max-width: 900px) {
  .stories-page-wrap > .stories {
    grid-template-columns: repeat(2, 1fr);
    padding: 0 22px;
    gap: 14px;
  }

  .stories-page-wrap > .stories .story.s1,
  .stories-page-wrap > .stories .story.s2,
  .stories-page-wrap > .stories .story.s3,
  .stories-page-wrap > .stories .story.s4,
  .stories-page-wrap > .stories .story.s5 {
    grid-column: span 2;
    grid-row: auto;
  }
}

.stories-intro {
  max-width: 760px;
  margin: 24px auto 40px;
  padding: 0 24px;
  text-align: center;
  color: var(--ink-dim);
  font-size: 15px;
  line-height: 1.65;
}
</style>
